<app-header-page>
    <h1>{{ 'HEADERS.DEPARTMENTS' | translate }}</h1>
</app-header-page>
<div class="content p-4 allTable">
    <button (click)="modalService.openTemplateModal(collectionView)"
            *ngIf="currentMember && currentMember.project_setting.observation_type !== 'dep_admin'"
            class="btn btn-primary btn-sm"
            data-action="createDepartment"
    >
        <span>{{ 'DEPARTMENTS.BUTTONS.CREATE' | translate }}</span>
    </button>
    <table class="table default-table table-tasks">
        <thead>
        <tr>
            <th class="deplist__name">{{ 'DEPARTMENTS.TITLE.NAME' | translate }}</th>
            <!--            <th class="deplist__admin">{{ 'DEPARTMENTS.TITLE.ADMIN' | translate }}</th>-->
            <th class="deplist__controls"></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="loading">
            <td colspan="3">
                <div class="donut blue"></div>
            </td>
        </tr>
        <tr *ngIf="!loading && !departmentsList.length">
            <td colspan="3">
                <b>
                    {{ 'EMPTY_LISTS.DEPARTMENTS' | translate }}
                </b>
            </td>
        </tr>
        <tr *ngFor="let department of departmentsList; let i = index"
            [attr.data-index-department]="i"
        >
            <td style="width: 500px;">
                {{ department.name }}
            </td>
            <!--            <td class="stat__col">-->
            <!--            <span class="stat__col__icon"-->
            <!--                  [class.active]="department.is_department_admin"-->
            <!--            >-->
            <!--                {{department.is_department_admin ? '&#10004;' : '&#10006;'}}-->
            <!--            </span>-->
            <!--            </td>-->
            <td>
                <div class="btn-group">
                    <button [routerLink]="[department.id]"
                            class="btn btn-light btn-sm roles"
                            data-action="manageDepartment"
                    >
                        <span>{{ 'DEPARTMENTS.BUTTONS.CONTROL' | translate }}</span>
                    </button>
                    <button (click)="deleteDepartment(department)"
                            [disabled]="isLockGroupButton[i]"
                            class="btn btn-danger btn-sm delete"
                            data-action="deleteDepartment"
                    >
                        <span *ngIf="!isLockGroupButton[i] else refresh">&times;</span>
                    </button>
                </div>
            </td>
        </tr>
        </tbody>
    </table>
</div>

<ng-template #collectionView let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.DEPARTMENT' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #name class="form-control">
        <button (click)="createDepartment(name.value, modal)"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="createDepartmentButton"
                style="margin-top: 13px;"
        >
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
